import { getMaxOrganizationsPerAccount } from '../../../../../../backend/utils/getMaxOrganizationsPerAccount';
import { LabelTypography } from '../../../../../../ui/components/LabelTypography';
import { OrganizationsSelectionAnonymous } from '../../../../../../ui/features/organizations/components/OrganizationsPanel/components/OrganizationsSelectionAnonymous';
import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { getPublicSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box, Button, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import React from 'react';
import { useSelector } from 'react-redux';
export const AccountMembershipAnonymousComponent = (props, ref) => {
    var _a;
    const navigationContext = React.useContext(NavigationContext);
    const { t } = useContactManagementTranslation();
    const settings = useSelector(getPublicSettings);
    const [statusData, setStatusData] = React.useState(Object.assign({}, (_a = props.data) === null || _a === void 0 ? void 0 : _a.orgStatus));
    const [validationMessage, setValidationMessage] = React.useState();
    const organizationIds = Object.keys(statusData);
    const handleSubmit = () => {
        if ((settings === null || settings === void 0 ? void 0 : settings.mustSelectMembershipAnonymousRegistration) && organizationIds.length === 0) {
            setValidationMessage(t('forms.publicRegistration.mustSelectAtLeastOneOrganization'));
            return Promise.reject(new Error(t('forms.publicRegistration.mustSelectAtLeastOneOrganization')));
        }
        const maxOrganizationsPerAccount = getMaxOrganizationsPerAccount(settings);
        if (maxOrganizationsPerAccount && organizationIds.length > maxOrganizationsPerAccount) {
            setValidationMessage(t('forms.publicRegistration.maxOrganizationsPerAccount', {
                count: maxOrganizationsPerAccount,
                deselectCount: organizationIds.length - maxOrganizationsPerAccount,
            }));
            return Promise.reject(new Error(t('forms.publicRegistration.maxOrganizationsPerAccount', {
                count: maxOrganizationsPerAccount,
                deselectCount: organizationIds.length - maxOrganizationsPerAccount,
            })));
        }
        const data = { orgStatus: statusData };
        const savePromise = props
            .onSubmit(data)
            .then((response) => {
            if (props.onSubmitSuccess) {
                props.onSubmitSuccess(data, response);
            }
        })
            .catch((error) => {
            handleErrorDialog(error);
            throw error;
        });
        navigationContext.save(savePromise);
        return savePromise;
    };
    React.useImperativeHandle(ref, () => ({
        submit: () => handleSubmit(),
        getData: () => ({ orgStatus: statusData }),
    }));
    const handleChangeOrganizationIds = (newOrganizationIds) => {
        var _a, _b, _c;
        const newStatusData = Object.assign({}, statusData);
        for (const orgId of organizationIds) {
            if (!newOrganizationIds.includes(orgId)) {
                delete newStatusData[orgId];
            }
        }
        for (const orgId of newOrganizationIds) {
            if (!organizationIds.includes(orgId)) {
                newStatusData[orgId] = 'pending';
            }
        }
        setStatusData(newStatusData);
        const wizard = ((_a = props.formParams) === null || _a === void 0 ? void 0 : _a.page) === 'new' ||
            ((_b = props.formParams) === null || _b === void 0 ? void 0 : _b.page) === 'public-registration' ||
            ((_c = props.formParams) === null || _c === void 0 ? void 0 : _c.page) === 'login-completion';
        if (!wizard) {
            navigationContext.setChanged(t('common.saveChanges'), handleSubmit);
        }
        if (props.onChanged) {
            props.onChanged(true, handleSubmit);
        }
    };
    return (React.createElement("div", null,
        validationMessage && (React.createElement(Box, { sx: { mb: 2 } },
            React.createElement(Alert, { severity: 'error' },
                React.createElement(Typography, { sx: { mb: 2 } }, t('common.formioErrorTitle')),
                validationMessage))),
        React.createElement(OrganizationsSelectionAnonymous, { organizationIds: organizationIds, onChangeOrganizationIds: handleChangeOrganizationIds, organizationSelectionRequired: settings.mustSelectMembershipAnonymousRegistration, renderOrganization: (organization) => (React.createElement(React.Fragment, null,
                React.createElement(LabelTypography, { sx: { flexGrow: 1 }, color: organization.disabled ? 'textSecondary' : 'initial', "aria-disabled": organization.disabled }, organization.name),
                organizationIds.includes(organization.id) && (React.createElement(React.Fragment, null,
                    React.createElement(Box, { sx: { ml: 2, mr: 2 } }, t('panels.accounts.joined')))))) }),
        props.showSubmitButton && (React.createElement(Box, { pt: 2, sx: { display: 'flex', justifyContent: 'flex-end' } },
            React.createElement(Button, { variant: 'contained', color: 'primary', onClick: () => handleSubmit() }, t('common.save'))))));
};
export const AccountMembershipAnonymous = React.forwardRef(AccountMembershipAnonymousComponent);
